import axios from 'axios';
import bearerTokenHeader from 'components/api-authorization/bearerToken';

export interface IEppDamper {
  eppDamperID: number;
  name: string;
  eppDamperTypeID: number;
  eppDiameterID: number;
}

export const getEppDampers = async () => {
  const config = await bearerTokenHeader();
  const response = await axios.get('api/EppDamper', config);
  return response.data;
};
